import { ChatPopup } from '../../components/ChatPopup';
import { useChatContext } from '../../context';
import { useOffer, usePublisher, useTracking } from '../../hooks';
import { FC, useMemo } from 'react';

export const ChatPopupContainer: FC = () => {
  const { offerWithChat, closeChat } = useChatContext();
  const { id, cianId, dealType, offerType, user, gaLabel } = useOffer();
  const { name } = usePublisher();
  const { onChatPopupOpen } = useTracking();

  const chatUrl = useMemo(() => {
    if (offerWithChat !== id) {
      return null;
    }

    onChatPopupOpen();

    return (
      `/dialogs/?hostType=frame&offerId=${cianId}` +
      `&dealType=${dealType}&offerType=${offerType}` +
      `${name ? '&companionName=' + encodeURIComponent(name) : ''}` +
      `${user?.cianUserId ? '&companionId=' + encodeURIComponent(user?.cianUserId) : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      '&pageType=CardHS'
    );
  }, [cianId, dealType, gaLabel, id, name, offerType, offerWithChat, onChatPopupOpen, user?.cianUserId]);

  if (!chatUrl) {
    return null;
  }

  return <ChatPopup chatUrl={chatUrl} onClose={closeChat} />;
};
